import { Image } from '@chakra-ui/react';
import React, { useState } from 'react';

type ImageWithFallbackProps = {
  defaultUrl?: string | null;
  fallbackUrl: string;
  alt: string;
  height?: number;
  width?: number;
};

export const ImageWithFallback = ({
  defaultUrl = null,
  fallbackUrl,
  alt,
  height,
  width,
}: ImageWithFallbackProps) => {
  const [imageUrl, setImageUrl] = useState(defaultUrl || fallbackUrl);

  return (
    <Image
      src={imageUrl}
      height={height ? `${height}px` : undefined}
      width={width ? `${width}px` : undefined}
      onError={() => setImageUrl(fallbackUrl)}
      alt={alt}
    />
  );
};
